import { AppThunk } from '../../../store/rootReducer';
import * as rulerActions from '../../ruler/actions/ruler.actions';
import { isUpdatingRulerSelector } from '../selectors/ruler.selectors';
import { isToolActiveSelector } from '../../tool/selectors/tool.selectors';
import { Tool } from '../../tool/utils/tool.utils';

export const startRuler = (timestamp: number): AppThunk => async (
  dispatch,
  getState,
) => {
  const isUpdatingRuler = isUpdatingRulerSelector(getState());
  const isRulerActive = isToolActiveSelector(Tool.ruler)(getState());

  if (!isUpdatingRuler && isRulerActive) {
    dispatch(
      rulerActions.setBoundary({
        boundary: 'end',
        timestamp,
      }),
    );
  }
};
